/**
 * Created by Ning Jiang on 5/9/2020.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {ITombstoneParsedServerData} from "../server/data/ITombstoneParsedServerData";

export class TombstoneRespinZeroBetController extends ZeroBetController {

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ITombstoneParsedServerData):boolean {
        return data.nextMode === GameMode.RESPIN;
    }

    protected getZeroBetNumberLeft(data:ITombstoneParsedServerData):number {
        return data.bonusSpinsLeft;
    }

    public shouldSubtractZeroBetCounter():boolean {
        return true;
    }

    public shouldShowZeroBetCounter():boolean {
        return true;
    }
}